import { FinancialType } from './financial-type';

export class FinancialArea {
  financialAreaId: number;
  name: string;
  financialTypes: FinancialType[];
}
